import type {HotelsPage, OffersPage} from '@/types';

export const ROUTES = {
  hotelsPage: 'hotels',
  offersPage: 'hotel/:hotelId/offers',
};

export const ONE_DAY_MS = 86_400_000;
export const ONE_HOUR_MS = 3_600_000;

export const PAGE_HOTELS: HotelsPage = 'hotels' as const;
export const PAGE_OFFERS: OffersPage = 'offers' as const;

// https://invia.atlassian.net/wiki/spaces/UFY/pages/42735971/Hotelqualit+t
export const REVIEW_SCORE_MAX = 5;
export const REVIEW_SCORE_MAX_BACKEND = 100;

export const REVIEW_SCORE_AMADEUS_MAX = 6;
export const REVIEW_SCORE_AMADEUS_MAX_BACKEND = 6;

export const REVIEW_SCORE_AMADEUS_THRESHOLD_EXCELLENT = 5.4;
export const REVIEW_SCORE_AMADEUS_THRESHOLD_VERY_GOOD = 4.8;
export const REVIEW_SCORE_AMADEUS_THRESHOLD_GOOD = 4.2;
export const REVIEW_SCORE_AMADEUS_THRESHOLD_FAIR = 3.6;

export const DEFAULT_REQUEST_TIMEOUT = 5000;

export const SPLIT_OVERRIDE_URL_PARAM = 's';

export const INVIA_TYPE_DISCOUNT = 'IT08P-DISC#DISC';

export const DYNCAMIC_SCARCITY_ELEMENT_HOTELLIST_THRESHOLD = 10;
export const DYNCAMIC_SCARCITY_ELEMENT_OFFERLIST_THRESHOLD = 10;
